// extracted by mini-css-extract-plugin
export default {"container":"Stats_container__kQu2B","filters":"Stats_filters__aO21s","tabs":"Stats_tabs__qzcIq","content":"Stats_content__4Hzjm"};